import { http } from '@api/client';
import { PaginatedResponse } from '@api/shared';
import { paramterize, pickResponse } from '@api/utils';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { mockAnalyticsResponse } from './mock-response';

interface DatabaseLogsDetail {
    "added_count": number,
    "data_field": string,
    "deleted_count": number,
    "log_date": string,
    "modified_count": number
}

export type FilterResponse = PaginatedResponse<DatabaseLogsDetail>;

export interface DatabaseLogsParams {
    filters?: Array<{ id: string; value: Record<string, any> }>;
    pageSize?: number;
    page?: number;
    sortBy?: Array<{ id: string; desc: boolean }>;
  }

export function getDataLogs({
    filters = [],
    pageSize: page_size = 10,
    page = 1,
    sortBy = [],
  }: DatabaseLogsParams = {}) {
    const sort = sortBy.map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`).join(';');
    const filtersMap: Record<string, string> = filters.reduce(
      (map, f) =>
        Object.assign(map, {
          [f.id]: Object.entries(f.value)
            .map(([op, v]) => (op === '$bw' ? `$gte|||${v[0]};$lte|||${v[1]}` : `${op}|||${v}`))
            .join(';'),
        }),
      {}
    );
  
    const params = paramterize({ page_size, page, sort, ...filtersMap });
  
    return http.get<FilterResponse>('count_data/searches', { params }).pipe(pickResponse());
  }

export function getLogsData({
    filters = [],
    pageSize: page_size = 10,
    page = 1,
    sortBy = [],
  }: DatabaseLogsParams = {}) {
    const sort = sortBy.map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`).join(';');
    const filtersMap: Record<string, string> = filters.reduce(
      (map, f) =>
        Object.assign(map, {
          [f.id]: Object.entries(f.value)
            .map(([op, v]) => (op === '$bw' ? `$gte|||${v[0]};$lte|||${v[1]}` : `${op}|||${v}`))
            .join(';'),
        }),
      {}
    );
  
    const params = paramterize({ page_size, page, sort, ...filtersMap });
  
    return http.get<FilterResponse>('log_data/searches', { params }).pipe(pickResponse());
  }

  const USE_MOCK_DATA = false;  // to be changed to false

  export function getDashboardAnalytics(/* {
  field,
  action,
  }: {
    field?: string;
    action?: string;
  } */) {
    if (USE_MOCK_DATA) {
      return of<any[]>(mockAnalyticsResponse);
    }

   /*  const filters = [];

    if (field) {
      filters.push({
        id: 'field_name',
        value: { $eq: field },
      });
    }

    if (action) {
      filters.push({
        id: 'action_filter',
        value: { $eq: action },
      });
    } */

    return getLogsData({
      pageSize: 1000,
    //  filters,
    }) .pipe(
          map(response => response.data.data)
        );;
  }